import React from 'react';

export default class SaveIndicatorUI extends React.Component {
    render() {
        if (this.props.activeSavesCount === undefined
            && this.props.failedSavesCount === undefined) {
                return <div ref={(indicator) => this.saveIndicator = indicator} />;
        }

        let icon = 'check_circle';
        let message = 'Saved';

        if (this.props.activeSavesCount > 0) {
            icon = 'hourglass_empty';
            message = 'Saving...';
        } else if (this.props.failedSavesCount > 0) {
            icon = 'warning';
            message = 'Not saved';
        }

        return (
            <div
                className="save-indicator d-flex align-items-center"
                ref={(indicator) => this.saveIndicator = indicator}
            >
                <i className="material-icons">{icon}</i>
                <span className="message">{message}</span>
            </div>
        );
    }
}
